import { Route } from '@angular/router';
import { authGuard } from '@routes/guards/auth.guard';
import { guard } from '@routes/guards/guard-factory';

export const competitionsRoutes: Route[] = [
    {
        path: 'competitions',
        title: 'PRSS | Соревнования',
        loadComponent: () =>
            import('@pages/guids/competitions/competitions.component').then(
                (c) => c.CompetitionsComponent,
            ),
        canActivate: [authGuard, guard('watch_refs_competitions')],
        data: {
            breadcrumbs: [
                { name: 'Справочники', url: '/' },
                { name: 'Соревнования', url: null },
            ],
            reuse: true,
            searchString: true,
        },
    },
    {
        path: 'competitions/create',
        title: 'PRSS | Загрузить соревнование',
        loadComponent: () =>
            import('@pages/guids/competitions/competitions.component').then(
                (c) => c.CompetitionsComponent,
            ),
        canActivate: [authGuard, guard('watch_refs_competitions')],
        data: {
            breadcrumbs: [
                { name: 'Справочники', url: '/' },
                { name: 'Соревнования', url: '/competitions' },
                { name: 'Загрузить из ИАС', url: null },
            ],
            searchString: false,
        },
    },
    {
        path: 'competitions/:iasId',
        title: 'PRSS | Соревнование',
        loadComponent: () =>
            import('@pages/guids/competitions/competition-details/competition-details.component').then(
                (c) => c.CompetitionDetailsComponent,
            ),
        canActivate: [authGuard],
        data: {
            breadcrumbs: [
                { name: 'Справочники', url: '/' },
                { name: 'Соревнования', url: '/competitions' },
            ],
            searchString: false,
        },
    },
];
